module.exports = __webpack_public_path__ + "static/media/separator.95e262b5.svg";